<template lang="pug">
.d-flex
  .flex-grow-1
    filter-date-range.mr-2(v-if="isSalesReport" ref="date" :dates.sync="datesFilter" initializeDate)
    filter-date-range-limit.mr-2(v-else ref="date" :dates.sync="datesFilter" initializeDate)
    filter-time-range.mr-2(ref="timeRange" :filter.sync="timeRangeFilter")
    filter-provider.mr-2(:filter.sync="providerFilter")
    filter-visit-codes.mr-2(:filter.sync="visitCodeFilter")
    filter-treatment-products.mr-2(:filter.sync="treatmentProductFilter")
    filter-payment-method(:filter.sync="paymentMethodFilter" @fetched="$emit('fetchedPaymentMethods', $event)")
  v-btn.button-sm.underline.px-0(text :disabled="allFilters.length === 0" @click="resetFilters") Reset filters
</template>

<script>
import FilterDateRange from '@/components/clinic/reports/filters/FilterDateRange.vue'
import FilterDateRangeLimit from '@/components/clinic/reports/filters/FilterDateRangeLimit.vue'
import FilterTimeRange from '@/components/clinic/reports/filters/FilterTimeRange.vue'
import FilterProvider from '@/components/clinic/reports/filters/FilterProvider.vue'
import FilterVisitCodes from '@/components/clinic/reports/filters/FilterVisitCodes.vue'
import FilterTreatmentProducts from '@/components/clinic/reports/filters/FilterTreatmentProducts.vue'
import FilterPaymentMethod from '@/components/clinic/reports/filters/FilterPaymentMethod.vue'

export default {
  components: { FilterProvider, FilterTimeRange, FilterDateRange, FilterDateRangeLimit, FilterVisitCodes, FilterTreatmentProducts, FilterPaymentMethod },
  props: ['filters'],
  data: () => ({
    key: 0,
    timeRangeFilter: {},
    providerFilter: {},
    visitCodeFilter: {},
    treatmentProductFilter: {},
    // dateFilter: null,
    datesFilter: [],
    paymentMethodFilter: {}
  }),
  watch: {
    allFilters (newValue) {
      this.$emit('update:filters', newValue)
    }
  },
  computed: {
    isSalesReport () {
      return this.Auth('component', '/admin/clinic/reports/sales#view_sales_report')
    },
    allFilters () {
      const filters = []
      if (this.providerFilter.key) {
        filters.push(this.providerFilter)
      }
      if (this.datesFilter.length > 0) {
        filters.push({ key: 'date__gte', value: this.datesFilter[0]})
        filters.push({ key: 'date__lte', value: this.datesFilter[1]})
      }
      if (this.timeRangeFilter.key) {
        filters.push(this.timeRangeFilter)
      }
      if (this.visitCodeFilter.key) {
        filters.push(this.visitCodeFilter)
      }
      if (this.treatmentProductFilter.key) {
        filters.push(this.treatmentProductFilter)
      }
      if (this.paymentMethodFilter.key) {
        filters.push(this.paymentMethodFilter)
      }
      return filters
    }
  },
  methods: {
    resetFilters () {
      this.providerFilter = {}
      this.timeRangeFilter = {}
      this.visitCodeFilter = {}
      this.treatmentProductFilter = {}
      this.paymentMethodFilter = {}
      this.datesFilter = []
      this.$refs.date.clear()
      this.$refs.timeRange.clear()
    },
  }
}
</script>